import request from '@/utils/request.js'
export function getAdminCardList(data){
    return request({
        url: 'history_sim/admin/listPage',
        method: 'post',
        data
    })
}

export function exportSimInfo(data){
    return request({
        url: 'export/history_simInfo',
        method: 'post',
        data
    })
}

/**
 * 
 * @param {恢复sim卡}} simId 
 */
export function resumeInfo(simId){
    return request({
        url: 'history_sim/resumeInfo/'+simId,
        method: 'post'
    })
}